import React from 'react';

import { useI18n } from '../../../../data/hooks/i18nHooks';
import Icon from '../../../elements/icons/Icon';
import Link from '../../../elements/Link';

const EventMapButton = (props) => {
    const { event, isActive } = props,
        i18n = useI18n();

    const handleOpenEventMap = (e) => {
        e.stopPropagation();
        e.preventDefault();

        app.store.dispatch(app.actions.ui.sidePanel.showEventMap(true));
    };

    if (!event.map_url) return null;

    return (
        <Link className={isActive ? 'is-active' : ''} href={['/events', event.id].join('/')} onClick={handleOpenEventMap}>
            <Icon size={24} src={`img/event_map.png`} color="white" />
            {i18n['label.map']}
        </Link>
    );
};

export default EventMapButton;
